// Selo do tipo e etiqueta da situação do desconto. Usados no cartão da lista e no topo do Show.
import { Box } from '@mui/material';
import { DiscountLike, DiscountStatus, DiscountTypeKey, StatusTone, typeKey, typeLabel } from './discountStatus';

const TYPE_STYLE: Record<DiscountTypeKey, { ink: string; tint: string }> = {
    [DiscountTypeKey.default]: { ink: '#455a64', tint: 'rgba(96,125,139,.12)' },
    [DiscountTypeKey.special]: { ink: '#1565c0', tint: 'rgba(25,118,210,.10)' },
    [DiscountTypeKey.reward]: { ink: '#6a1b9a', tint: 'rgba(123,31,162,.09)' },
    [DiscountTypeKey.recovery]: { ink: '#bf360c', tint: 'rgba(230,81,0,.09)' },
};

// Mesmas cores dos Alert do MUI (success, info, error) e um cinza para "acabou" e "substituído".
const TONE_STYLE: Record<StatusTone, { bg: string; fg: string; dot: string }> = {
    [StatusTone.success]: { bg: 'rgb(237,247,237)', fg: 'rgb(30,70,32)', dot: '#2e7d32' },
    [StatusTone.info]: { bg: 'rgb(229,246,253)', fg: 'rgb(1,67,97)', dot: '#0288d1' },
    [StatusTone.neutral]: { bg: '#f1f5f9', fg: '#475569', dot: '#94a3b8' },
    [StatusTone.error]: { bg: 'rgb(253,237,237)', fg: 'rgb(95,33,32)', dot: '#d32f2f' },
};

export const TypeBadge = ({ record }: { record: DiscountLike }) => {
    const key = typeKey(record);
    const { ink, tint } = TYPE_STYLE[key];
    return (
        <Box
            component="span"
            sx={{ fontSize: 11.5, fontWeight: 700, letterSpacing: '.04em', color: ink, bgcolor: tint, borderRadius: '999px', px: 1, py: '2px', whiteSpace: 'nowrap' }}
        >
            {typeLabel(key)}
        </Box>
    );
};

export const StatusChip = ({ status }: { status: DiscountStatus }) => {
    const { bg, fg, dot } = TONE_STYLE[status.tone];
    return (
        <Box
            component="span"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: 12.5, fontWeight: 700, color: fg, bgcolor: bg, borderRadius: '999px', px: 1.25, py: '3px', maxWidth: '100%' }}
        >
            <Box component="span" aria-hidden="true" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: dot, flex: 'none' }} />
            <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>{status.text}</Box>
        </Box>
    );
};
